import React, { useEffect, useRef, useState } from "react";
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import SelectChannelSideBarComponent from "../channels/select-channel-side-bar-component";
import * as selector from '../../selectors/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { ChannelAccountModel, ChannelAccountStatus, ChannelType, ChanneTicketingPriority, ChanneTicketingStatus } from "../../models/channels/channels.model";
import { FacebookActiveIcon, InstaActiveIcon, LiveChatIcon, GoogleBusinessIcon, WhatsappActiveIcon, AllChannelsIcon, TicketHighIcon, TicketingStatusClosedIcon, TicketingStatusOpenIcon, TicketLowIcon, TicketMediumIcon, ConversationSortIcon, ConversationFilterRemoveIcon, EditFilterIcon } from "../../icon";
import ConversationCardsHeader from "./channels-conversation-cards-header";
import { ChannelConversationItem, ChannelConversationStatus, ChannelConversationCardModel, ConversationCardModel } from "../../models/conversations";
import ConversationTabsComponent from "./conversation-tabs.component";
import { ChannelUserModel } from "../../models/users.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import { useLocation, useNavigate } from "react-router";
import BlankConvHistory from "./blank-conv-history";
import ConversationHistoryComponent from "./conversation-history-component";
import { LoadConnectMessages } from "../../actions";
import { AppRoutes } from "../routes/route.path";
import { UtilityService } from "../../services/UtilityService";
import ConversationCardsFilterComponent from "./conversation-cards-filter.component";
import { Grid, Popover } from "@mui/material";
import { updateChannelConversations } from "../../reducers/reducer";
import NoDataComponent from "./no-data-component";
import PageHeaderComponent from "../shared/page-header.component";
import { pageTitles } from "../shared/constants";



interface IProps {

}

enum colors {
    Today = "#F4F5FA",
    Week = "#F4F5FA",
    One_Month = "#F4F5FA",
    Unread = "#AFD8A736",
    Archived = "#EFF1F8",
    Assigned_to_Me = "#145CFF2F",
    Medium = "#FFF5E0",
    Low = "#165CF31C",
    High = "#FFF2F2",
    Open = "#EEFDEA",
    Closed = "#FEE3E9",
}

const Conversations: React.FC<IProps> = (Props: IProps) => {

    const scrollRef = useRef<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)
    const LoadingConversations: boolean = useSelector(selector.LoadingConnect);
    const User: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();
    const ChannelConversations: ChannelConversationItem[] = useSelector(selector.ChannelConversations);
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const Alert: boolean = useSelector(selector.showingAlert)
    const DeviceHeight: number = useSelector(selector.deviceHeight)
    const LoadingChannels: boolean = useSelector(selector.LoadingChannels)

    const [height, setHeight] = useState<number>(0)
    const [sidebarWidth, setSidebarWidth] = useState<number>(IsMobileDevice ? 10 : 24);
    const [activeCard, setActiveCard] = useState<ChannelConversationCardModel>()
    const [convCardsData, setConvCardsData] = useState<ChannelConversationCardModel[]>([])
    const [searchText, setSearchText] = useState<string>("")
    const [unreadCount, setUnreadCount] = useState<number>(0)
    const [pathName, setPathName] = useState<string>("")
    const [activeCardIndex, SetActiveCardIndex] = useState<number>(0)
    const [howerOption, setHowerOption] = useState<string>("")

    const AllFilters: {
        FilterCatogaryLabel: string,
        MultiSelection?: boolean,
        FilterHeaders: {
            Label: string,
            Selected: boolean,
            Icon?: any
        }[],
    }[] = [
            {
                FilterCatogaryLabel: "Timeline",
                FilterHeaders: [{
                    Label: "Today",
                    Selected: false
                },
                {
                    Label: "7 Days",
                    Selected: false
                },
                {
                    Label: "One Month",
                    Selected: false
                },
                {
                    Label: "All Time",
                    Selected: true
                },
                ]
            },
            {
                FilterCatogaryLabel: "Priority",
                MultiSelection: true,
                FilterHeaders: [{
                    Label: "Low",
                    Selected: false,
                    Icon: <TicketLowIcon className='min-w-2 min-h-2' />
                }, {
                    Label: "Medium",
                    Selected: false,
                    Icon: <TicketMediumIcon className='min-w-2 min-h-2' />
                }, {
                    Label: "High",
                    Selected: false,
                    Icon: <TicketHighIcon className='min-w-2 min-h-2' />
                },]
            },
            {
                FilterCatogaryLabel: "Category",
                MultiSelection: true,
                FilterHeaders: [{
                    Label: "Archived",
                    Selected: false
                },
                {
                    Label: "Unread",
                    Selected: false
                },
                {
                    Label: "Assigned to Me",
                    Selected: false
                }]
            },
            {
                FilterCatogaryLabel: "Status",
                MultiSelection: true,
                FilterHeaders: [{
                    Label: "Open",
                    Selected: false,
                    Icon: <TicketingStatusOpenIcon className='min-w-2 min-h-2' />
                },
                {
                    Label: "Closed",
                    Selected: false,
                    Icon: <TicketingStatusClosedIcon className='min-w-2 min-h-2' />
                }]
            }
        ]

    const [anchorEl, SetAnchorEl] = useState(null);
    const [allFilters, setAllFilters] = useState<{
        FilterCatogaryLabel: string,
        MultiSelection?: boolean,
        FilterHeaders: {
            Label: string,
            Selected: boolean,
            Icon?: any
        }[],
    }[]>(AllFilters)

    const initialChannelOptions = [
        { Label: "All", ChannelType: 100, hasSubOptions: false, SubOptions: Channels.map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: AllChannelsIcon, Icon: AllChannelsIcon, Active: false, SubOptionsOpen: false },
        { Label: "Facebook", ChannelType: ChannelType.FACEBOOK, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).map((x, index) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: FacebookActiveIcon, Icon: FacebookActiveIcon, Active: ActiveChannelsTypes.includes(1), SubOptionsOpen: false },
        { Label: "Instagram", ChannelType: ChannelType.INSTAGRAM, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: InstaActiveIcon, Icon: InstaActiveIcon, Active: (ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(1)), SubOptionsOpen: false },
        { Label: "Livechat", ChannelType: ChannelType.LIVE_CHAT, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT && (x.Status === ChannelAccountStatus.CONNECTED || x.Status === ChannelAccountStatus.DISCONNECTED)).map((x, index) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: LiveChatIcon, Icon: LiveChatIcon, Active: (ActiveChannelsTypes.includes(4) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2)), SubOptionsOpen: false },
        { Label: "Google Business Messages", ChannelType: ChannelType.GOOGLE_BUSINESS, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: GoogleBusinessIcon, Icon: GoogleBusinessIcon, Active: false, SubOptionsOpen: false },
        { Label: "Whatsapp", ChannelType: ChannelType.WHATSAPP, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: WhatsappActiveIcon, Icon: WhatsappActiveIcon, Active: (ActiveChannelsTypes.includes(3) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(4)), SubOptionsOpen: false }
    ]

    const [channelOptions, setChannelOptions] = useState<any[]>(initialChannelOptions);
    const [activeChannel, setActiveChannel] = useState<any>("");
    const [activePage, setActivePage] = useState<any>("");

    // useLayoutEffect(() => {
    //     setPathName(location.pathname)
    // }, [location.pathname]);

    const refreshHandler = () => {
        navigate(AppRoutes.CONVERSATIONS);
    }

    const conversationTabs = [
        {
            id: 1,
            label: "Active",
            value: "ActiveTab",
            isLoading: LoadingConversations,
            maxSize: IsMobileDevice ? "min-w-10" : "max-w-9",
            data: convCardsData.filter(x => x.Status !== ChannelConversationStatus.CONVERSATION_DELETED).filter(x => x.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.FirstName?.toLowerCase().includes(searchText.toLowerCase()) || x.Message?.toLowerCase().includes(searchText.toLowerCase())).filter(x => x.Status !== ChannelConversationStatus.LIVECHAT_USER_CREATED).sort((a, b) => new Date(a.MessageDateTime) > new Date(b.MessageDateTime) ? -1 : 1) as ChannelConversationCardModel[]
        }
    ]

    useEffect(() => {
        let pathName = location.pathname
        let selectedId = pathName.slice(pathName.lastIndexOf("/") + 1, pathName.length)
        setPathName(selectedId)
        if (!ChannelConversations.length && Channels.length) {
            let initialActiveChannel = initialChannelOptions.find(x => ActiveChannelsTypes.includes(x.ChannelType))
            setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: false } : x))
            setActiveChannel(initialActiveChannel)
            setActivePage(initialActiveChannel.SubOptions[0])
        }
        if (selectedId !== "conversations" && !!ChannelConversations.length) {
            const data = (ChannelConversations.map((data: ChannelConversationItem) => ({ ...data, IsActive: false })).find(x => x.ID === selectedId))
            if (!data) {
                navigate(AppRoutes.CONVERSATIONS)
                return
            }
            setActiveCard({ ...data, IsActive: true })
            setChannelOptions(initialChannelOptions.map(x => x.ChannelType === data.Type ? { ...x, Active: true } : { ...x, Active: false }))
            let Channel = initialChannelOptions.find(x => x.ChannelType === data.Type)
            setActiveChannel({ ...Channel, Active: true })
            setActivePage(Channel.SubOptions.find(x => x.ID === data.AccountId))
            ApplySelectedFilters(allFilters, Channel.SubOptions.find(x => x.ID === data.AccountId), selectedId)
        }
        if (selectedId === "conversations" && !!ChannelConversations.length) {
            if (!!ActiveChannelsTypes.length && !!Channels.length) {
                setActiveCard(undefined)
                if (activePage && activeChannel) {
                    ApplySelectedFilters(allFilters, activePage, "")
                }
                else {
                    let initialActiveChannel = initialChannelOptions.find(x => ActiveChannelsTypes.includes(x.ChannelType))
                    setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: false } : x))
                    setActiveChannel(initialActiveChannel)
                    setActivePage(initialActiveChannel.SubOptions[0])
                    ApplySelectedFilters(allFilters, initialActiveChannel.SubOptions[0], "")
                }
            }
        }
    }, [location.pathname, ChannelConversations, Channels, ActiveChannelsTypes])

    useEffect(() => {
        setHeaderTitle("Conversations")
        setRefreshHandler(refresh)
    }, [])

    useEffect(() => {
        setHeaderCount(`${convCardsData.filter(x => x.Status !== ChannelConversationStatus.CONVERSATION_DELETED).filter(x => x.Status !== ChannelConversationStatus.LIVECHAT_USER_CREATED)?.length} conversations`)
    }, [convCardsData])

    const refresh = () => {
        dispatch(updateChannelConversations([]));
        setConvCardsData([])
        setActiveCard(undefined)
        navigate(AppRoutes.CONVERSATIONS)
        LoadConnectMessages(dispatch, ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID)
    }

    useEffect(() => {
        getHeight();
    }, [Alert, DeviceHeight])

    const handleSideBarWidth = (number) => {
        setSidebarWidth(number)
    }

    const handleSearch = (value: string) => {
        setSearchText(value)
    }

    const toggleCardActive = (data: ConversationCardModel, index: number) => {
        let id = (data as ChannelConversationItem)?.ID
        SetActiveCardIndex(index)
        setUnreadCount((data as ChannelConversationItem)?.UnReadCount)
        navigate(IsTeamsApp ? `/teams/conversations/${id}` : `/conversations/${id}`)
    }

    const backHandler = () => {
        setActiveCard(undefined);
        refreshHandler()
    }

    const getHeight = () => {
        let height = IsMobileDevice ? UtilityService.getHeightByPercentage(DeviceHeight, [Alert ? 92 : 100, 92, 90]) : UtilityService.getHeightByPercentage(DeviceHeight, [Alert ? 92 : 100, 93, 94, 96, 96, 90])
        setHeight(height)
    }

    const handleChannelOptions = (ChannelOptions) => {
        let ActiveChannel = ChannelOptions.find(x => x.Active === true)
        setChannelOptions(ChannelOptions)
        setActiveChannel(ActiveChannel)
        setActivePage(!!ActiveChannel.SubOptions?.length ? ActiveChannel.SubOptions.find(x => x.Active) : "")
        ApplySelectedFilters(allFilters, !!ActiveChannel.SubOptions?.length ? ActiveChannel.SubOptions.find(x => x.Active) : "", "")
        setActiveCard(undefined)
        navigate(AppRoutes.CONVERSATIONS)
    }

    const handlePage = (page) => {
        setActivePage(page)
        setConvCardsData(ChannelConversations.map(data => ({ ...data, IsActive: false })).filter(x => x.AccountId === page.ID))
        setActiveCard(undefined)
        ApplySelectedFilters(allFilters, page, "")
        navigate(AppRoutes.CONVERSATIONS)
    }


    const handleClickFilter = (event: React.MouseEvent) => {
        SetAnchorEl(event.currentTarget);
    };

    const handleCloseFilter = () => {
        SetAnchorEl(null);
    };

    const ApplySelectedFilters = (selectedFilters: { FilterCatogaryLabel: string, FilterHeaders: { Label: string, Selected: boolean, Icon?: any }[], }[], selectedPage, selectedConvId) => {

        let Filters = selectedFilters.flatMap(x => x.FilterHeaders);

        let TotalData = ChannelConversations.map(data => ({ ...data, IsActive: data.ID === selectedConvId })).filter(x => x.AccountId === selectedPage?.ID)

        if (!selectedPage) {
            setConvCardsData([])
            setActivePage("")
            setActiveCard(undefined)
            setAllFilters(selectedFilters);
            handleCloseFilter();
            setHowerOption("")
            return
        }

        if (!Filters.find(x => x.Selected)) {
            setConvCardsData(TotalData)
            setAllFilters(selectedFilters);
            handleCloseFilter();
            setHowerOption("")
            return
        }

        let FilteredCustomData = TotalData;

        let StatusFilteredCustomData = [];

        let PriorityFilteredCustomData = [];

        if (Filters.find(y => y.Label === "Open").Selected) {
            StatusFilteredCustomData = [...FilteredCustomData.filter(x => x.Ticket.Status === ChanneTicketingStatus.Open)]
            FilteredCustomData = StatusFilteredCustomData
        }
        if (Filters.find(y => y.Label === "Closed").Selected) {
            StatusFilteredCustomData = [...StatusFilteredCustomData, ...TotalData.filter(x => x.Ticket.Status === ChanneTicketingStatus.Closed)]
            FilteredCustomData = StatusFilteredCustomData
        }

        StatusFilteredCustomData = !!StatusFilteredCustomData?.length ? StatusFilteredCustomData : TotalData;

        if (Filters.find(y => y.Label === "Low").Selected) {
            PriorityFilteredCustomData = [...StatusFilteredCustomData.filter(x => x.Ticket.Priority === ChanneTicketingPriority.Low)]
            FilteredCustomData = PriorityFilteredCustomData
        }

        if (Filters.find(y => y.Label === "Medium").Selected) {
            PriorityFilteredCustomData = [...PriorityFilteredCustomData, ...StatusFilteredCustomData.filter(x => x.Ticket.Priority === ChanneTicketingPriority.Medium)]
            FilteredCustomData = PriorityFilteredCustomData
        }

        if (Filters.find(y => y.Label === "High").Selected) {
            PriorityFilteredCustomData = [...PriorityFilteredCustomData, ...StatusFilteredCustomData.filter(x => x.Ticket.Priority === ChanneTicketingPriority.High)]
            FilteredCustomData = PriorityFilteredCustomData
        }

        if (Filters.find(y => y.Label === "Archived").Selected) {
            FilteredCustomData = [...FilteredCustomData.filter(x => x.IsArchived)]
        }

        if (Filters.find(y => y.Label === "Unread").Selected) {
            FilteredCustomData = [...FilteredCustomData.filter(x => x.UnReadCount)]
        }

        if (Filters.find(y => y.Label === "Assigned to Me").Selected) {
            FilteredCustomData = [...FilteredCustomData.filter(x => x.Ticket.Assigned_To === User.ID)]
        }

        if (Filters.find(y => y.Label === "One Month").Selected) {
            const today = UtilityService.convertToPreferredTimeZone(new Date());
            const thirtyDaysAgo = new Date(today);
            thirtyDaysAgo.setDate(today.getDate() - 29); // includes today
            thirtyDaysAgo.setHours(0, 0, 0, 0);

            FilteredCustomData = FilteredCustomData.filter(x => {
                const msgDate = UtilityService.convertToPreferredTimeZone(new Date(x.MessageDateTime));
                return msgDate >= thirtyDaysAgo;
            });
        }

        if (Filters.find(y => y.Label === "7 Days").Selected) {
            const today = UtilityService.convertToPreferredTimeZone(new Date());
            const sevenDaysAgo = new Date(today);
            sevenDaysAgo.setDate(today.getDate() - 6);
            sevenDaysAgo.setHours(0, 0, 0, 0);

            FilteredCustomData = FilteredCustomData.filter(x => {
                const msgDate = UtilityService.convertToPreferredTimeZone(new Date(x.MessageDateTime));
                return msgDate >= sevenDaysAgo;
            });
        }

        if (Filters.find(y => y.Label === "Today").Selected) {
            const today = UtilityService.convertToPreferredTimeZone(new Date());
            const startOfDay = new Date(today.setHours(0, 0, 0, 0));

            FilteredCustomData = FilteredCustomData.filter(x => {
                const msgDate = UtilityService.convertToPreferredTimeZone(new Date(x.MessageDateTime));
                return msgDate >= startOfDay;
            });
        }

        setConvCardsData(FilteredCustomData)
        setAllFilters(selectedFilters);
        handleCloseFilter();
        setHowerOption("")
    }

    return (
        <div className="w-p-100 h-p-100 d-flex flex-direction">
            {(IsMobileDevice && !activeCard) && <div className='w-p-98 d-flex justify-center align-center h-p-8'>
                <PageHeaderComponent
                    Reload={() => { }}
                    HeaderText={pageTitles.CONVERSATIONS}
                    HideSearch={true}
                    ShowFilterIcon={false} />
            </div>}
            {!IsMobileDevice &&
                <div className="w-p-100 h-p-6 d-flex align-center justify-center">
                    <div className="w-p-96 h-p-100 d-flex align-end">
                        <ConversationSortIcon className="mr-1 mb-1" />
                        <div className="h-4 h5-medium br-4 bg-color-import-contacts-outlook-border d-flex align-center px-2 mr-1 color-secondary">
                            Sort by : Recent
                        </div>
                    <ConversationCardsFilterComponent AllFilters={allFilters} OnClose={handleCloseFilter} ApplySelectedFilters={(selectedFilters) => ApplySelectedFilters(selectedFilters, activePage, pathName !== "conversations" ? pathName : "")} />
                    </div>
                </div>
            }
            {IsMobileDevice ?
                (Channels.length && channelOptions.find(x => x.Active)?.SubOptions.length && !LoadingChannels) ?

                    activeCard ?
                        <ConversationHistoryComponent
                            pathName={pathName}
                            activeCardIndex={activeCardIndex}
                            UnreadCount={unreadCount}
                            BackHandler={backHandler}
                            CardData={activeCard}
                            deviceHeight={100}
                            IsMobileDevice={IsMobileDevice}
                            ActiveCardIndex={activeCardIndex}
                            IsDisabled={false}
                            scrollRef={scrollRef}
                        />
                        :
                        <div className={`flex-1 h-p-92 bg-color-secondary d-flex flex-direction px-1`}>
                            <div className="h-p-10 d-flex align-center conv-card-border">
                                <ConversationCardsHeader handleSearch={handleSearch} pages={!!activeChannel.SubOptions?.length ? activeChannel.SubOptions : []} activePage={activePage} handlePage={handlePage} handleFilter={handleClickFilter} SelectChannel={true} ChannelOptions={channelOptions} handleChannelOptions={handleChannelOptions} />
                            </div>
                            <div className="h-p-90">
                                <ConversationTabsComponent conversationTabs={conversationTabs} DeviceHeight={height} toggleCardActive={toggleCardActive} scrollRef={scrollRef} />
                            </div>
                        </div>

                    :
                    <div className={`bg-color-secondary flex-1 h-p-96 my-auto mr-2 select-channel-active-border br-2 ml-2`}>
                        {(LoadingChannels || LoadingConversations) ?
                            <NoDataComponent Message={"Please wait while we ready conversations for you..."} />
                            :
                            <NoDataComponent Message={<div>Looks like it’s quiet here! Start by connecting a <span className="color-primary-light mx-1 c-pointer w-space" onClick={() => navigate(AppRoutes.ADD_CHANNELS)}> Channel </span> and let the conversations flow.</div>} />
                        }
                    </div>
                :
                <div className="w-p-100 h-p-94 br-3 d-flex align-center justify-center">
                    <div className="w-p-96 h-p-96 bg-color-side-bar br-3 d-flex">
                        <div className={`min-w-${sidebarWidth} min-w-${sidebarWidth} max-w-${sidebarWidth} d-flex align-center justify-center h-p-96 my-auto ml-2 select-channel-active-border br-2`}>
                            <SelectChannelSideBarComponent Options={channelOptions} handleSidebarWidth={handleSideBarWidth} handleOptions={handleChannelOptions} />
                        </div>
                    {(Channels.length && channelOptions.find(x => x.Active)?.SubOptions.length && !LoadingChannels) ?
                        <>
                            <div className={`bg-color-secondary min-w-50 h-p-96 my-auto mx-2 select-channel-active-border br-2 d-flex flex-direction `}>
                                <div className="w-p-100 h-p-10 d-flex align-center conv-card-border">
                                    <div className="w-p-100">
                                        <ConversationCardsHeader handleSearch={handleSearch} pages={!!activeChannel.SubOptions?.length ? activeChannel.SubOptions : []} activePage={activePage} handlePage={handlePage} handleFilter={handleClickFilter} />
                                    </div>
                                </div>
                                <div className="w-p-100 h-p-90">
                                    <ConversationTabsComponent conversationTabs={conversationTabs} DeviceHeight={height} toggleCardActive={toggleCardActive} scrollRef={scrollRef} />
                                </div>
                            </div>
                            <div className={`bg-color-secondary flex-1 h-p-96 my-auto mr-2 select-channel-active-border br-2 min-w-60`}>
                                <div className="m-auto h-p-100">
                                    {
                                        activeCard ?
                                            <ConversationHistoryComponent
                                                pathName={pathName}
                                                activeCardIndex={activeCardIndex}
                                                UnreadCount={unreadCount}
                                                BackHandler={backHandler}
                                                CardData={activeCard}
                                                deviceHeight={100}
                                                IsMobileDevice={IsMobileDevice}
                                                ActiveCardIndex={activeCardIndex}
                                                IsDisabled={false}
                                                scrollRef={scrollRef}
                                            />
                                            :
                                            <BlankConvHistory />
                                    }
                                </div>
                            </div>
                        </>
                            :
                            <div className={`bg-color-secondary flex-1 h-p-96 my-auto mr-2 select-channel-active-border br-2 min-w-60 ml-2`}>
                                {(LoadingChannels || LoadingConversations) ?
                                    <NoDataComponent Message={"Please wait while we ready conversations for you..."} />
                                    :
                                <NoDataComponent Message={<div>Looks like it’s quiet here! Start by connecting a<span className="color-primary-light mx-1 c-pointer w-space" onClick={() => navigate(AppRoutes.ADD_CHANNELS)}>Channel</span>and let the conversations flow.</div>} />
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            {
                Boolean(anchorEl) &&
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleCloseFilter}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    classes={{ paper: ` ${IsMobileDevice ? "w-p-100 min-h-5" : "max-h-44"}` }}
                >
                    <ConversationCardsFilterComponent AllFilters={allFilters} OnClose={handleCloseFilter} ApplySelectedFilters={(selectedFilters) => ApplySelectedFilters(selectedFilters, activePage, pathName !== "conversations" ? pathName : "")} />
                </Popover>
            }
        </div >
    )

}

export default Conversations;